import GlobalContext from 'Contexts/GlobalContext'
import { formatNumber, percentOfPopulation } from 'Utils'
import { useContext, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useEventListener, useWindowSize } from 'usehooks-ts'

window.nachnamen = window.nachnamen || {}

export const AllNamesTable = ({ currentLocale }: { currentLocale: any }) => {
  const { width } = useWindowSize()
  const isMobile = width < 712
  const [allNamesData, setAllNamesData] = useState<any>(
    window.nachnamen.allnames ? window.nachnamen.allnames : undefined
  )
  const [currentName, setCurrentName] = useState<CurrentName>(
    window.nachnamen.currentName ? window.nachnamen.currentName : undefined
  )
  const [drawData, setDrawData] =
    useState<{ name: string; count: number; rank: number }[]>()
  const [showAll, setShowAll] = useState(false)
  const tableRef = useRef<HTMLTableElement>(null)
  const [foundName, setFoundName] = useState<{
    name: string
    count: number
    rank: number
  }>()
  const [currentInFirst100, setCurrentInFirst100] = useState(false)
  const headRef = useRef<HTMLTableSectionElement>(null)
  useEventListener('allnames_loaded' as any, () => {
    setAllNamesData(window.nachnamen.allnames)
  })
  useEventListener('name_changed' as any, () => {
    setCurrentName(window.nachnamen.currentName)
  })
  useEffect(() => {
    if (!currentName) return
    if (!allNamesData) return

    const found:
      | {
          name: string
          count: number
          rank: number
        }
      | undefined = allNamesData.find((d: { name: string }) =>
      d.name.toLowerCase().split(',').includes(currentName.name.toLowerCase())
    )
    const reducedData = allNamesData.slice(0, showAll ? 100 : 10)
    if (found) {
      setFoundName(found)

      const currentIsInFirst100 =
        reducedData.find((d: { name: string }) => d.name === found.name) !==
        undefined
      setCurrentInFirst100(currentIsInFirst100)

      if (!currentIsInFirst100) {
        found.name = currentName.name
        reducedData.push({
          name: found.name,
          count: found.count,
          rank: found.rank,
        })
      }
    }
    setDrawData(reducedData)
  }, [currentName, allNamesData, showAll])

  useEffect(() => {
    setShowAll(false)
  }, [currentName])

  const c = currentLocale
  return (
    <AllNamesTableRoot>
      {/* <Title>{c.allTableTitle}</Title> */}
      {!drawData && <>{c.loading}</>}
      {drawData && (
        <>
          <TableWrapper
            className={showAll ? '' : 'hideScrollBar'}
            ref={headRef}
          >
            <Table id='nametable' ref={tableRef}>
              <Head>
                <Row>
                  <NumberCell
                    style={{
                      width: isMobile ? '120px' : '120px',
                      paddingRight: '10px',
                      textAlign: 'center',
                    }}
                  >
                    {c.allNameTableCols[0]}
                  </NumberCell>
                  <Cell> {c.allNameTableCols[1]}</Cell>
                  <NumberCell style={{ width: isMobile ? '120px' : '80px' }}>
                    {c.allNameTableCols[2]}
                  </NumberCell>
                  {/* <NumberCell style={{ width: isMobile ? '60px' : '100px' }}>
                    {c.allNameTableCols[3]}
                  </NumberCell> */}
                </Row>
              </Head>
            </Table>
          </TableWrapper>
          <FixedContainer>
            <TableWrapper className={showAll ? 'isopen' : 'hideScrollBar'}>
              <Table id='nametable' ref={tableRef}>
                <Body>
                  <>
                    {drawData
                      .slice(0, showAll ? 99 : 10)
                      .map(({ name, rank, count }, i) => {
                        return (
                          <Row
                            key={'allnamestable_row_' + i}
                            className={
                              foundName
                                ? name === foundName?.name
                                  ? 'searched'
                                  : ''
                                : ''
                            }
                          >
                            <NumberCell
                              style={{
                                width: isMobile ? '120px' : '120px',
                                paddingRight: '10px',
                                textAlign: 'center',
                              }}
                            >
                              <b>{formatNumber(rank)}</b>
                            </NumberCell>
                            <Cell>{name}</Cell>
                            <NumberCell
                              style={{ width: isMobile ? '120px' : '80px' }}
                            >
                              {formatNumber(count)}
                            </NumberCell>
                            {/* <NumberCell
                              style={{ width: isMobile ? '60px' : '100px' }}
                            >
                              {percentOfPopulation(count)}
                            </NumberCell> */}
                          </Row>
                        )
                      })}
                  </>
                </Body>
              </Table>
            </TableWrapper>
            {foundName && !currentInFirst100 && (
              <TableWrapper
                className={showAll ? 'extra' : 'extra hideScrollBar'}
              >
                <Table id='nametable' ref={tableRef}>
                  <Body>
                    <Row className='searched'>
                      <NumberCell
                        style={{
                          width: isMobile ? '60px' : '120px',
                          paddingRight: '10px',
                          textAlign: 'center',
                        }}
                      >
                        <b>{formatNumber(foundName.rank)}</b>
                      </NumberCell>
                      <Cell>{currentName.name}</Cell>
                      <NumberCell style={{ width: isMobile ? '60px' : '80px' }}>
                        {formatNumber(foundName.count)}
                      </NumberCell>
                      {/* <NumberCell
                        style={{ width: isMobile ? '60px' : '100px' }}
                      >
                        {percentOfPopulation(foundName.count)}
                      </NumberCell> */}
                    </Row>
                  </Body>
                </Table>
              </TableWrapper>
            )}
            <Fixed>
              <TableWrapper className='hideScrollBar'>
                <Table>
                  <Body>
                    <Row>
                      <Cell style={{ border: 0, textAlign: 'center' }}>
                        <ShowMore
                          onClick={() => {
                            if (headRef.current && isMobile) {
                              headRef.current.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                              })
                            }
                            setShowAll(!showAll)
                          }}
                          style={{ border: 0 }}
                        >
                          {showAll
                            ? c.allNameTableShowLess
                            : c.allNameTableShowMore}
                        </ShowMore>
                      </Cell>
                    </Row>
                  </Body>
                </Table>
              </TableWrapper>
            </Fixed>
          </FixedContainer>
        </>
      )}
    </AllNamesTableRoot>
  )
}
const FixedContainer = styled.div.attrs({ className: 'fixed-container' })`
  position: relative;
  height: 100%;
`
const Fixed = styled.div`
  &.fixed {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: var(--map-background-color);
  }
`

const AllNamesTableRoot = styled.div`
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 30px) !important;
  }
`
const Title = styled.h4`
  text-align: center;
`
const TableWrapper = styled.div`
  max-height: 500px;
  overflow-y: scroll;
  &.extra {
    border-top: 1px dashed var(--text-color);
    padding-top: 10px;
  }
  &.hideScrollBar {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  &.isopen {
    position: relative;
    &::after {
      content: '';
      display: inline-block;
      position: sticky;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 70px;
      border-bottom: 1px solid var(--table-gradient-border-color);
      background: var(--table-gradient-2);
    }
  }
`
const Table = styled.table`
  font-size: 18px;
  width: calc(100% - 0px);
  table-layout: fixed;
  /* background-color: var(--site-background); */
  border-collapse: collapse;

  @media screen and (max-width: 711px) {
    font-size: 14px;
  }
`
const Head = styled.thead`
  font-size: 14px;
  color: var(--gray-3);
  td {
    border-color: var(--text-color);
  }
`
const Body = styled.tbody``

const Row = styled.tr`
  &.searched {
    td {
      background-color: var(--purple-main);
      color: #fff;
    }
  }
`
const Cell = styled.td`
  border-bottom: 1px solid var(--table-cell-border-color);
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  overflow-x: hidden;

  padding: 4px;
  @media screen and (max-width: 711px) {
    padding: 2px;
  }
  &.searched {
    background-color: var(--gray-4);
  }
`
const NumberCell = styled(Cell)`
  text-align: right;
  padding-right: 10px;
  @media screen and (max-width: 711px) {
    font-size: 13px;
  }
`
// const ShowMore = styled.div`
//   padding: 1rem;
//   text-align: center;
//   margin-left: auto;
//   margin-right: auto;
//   display: inline-block;
//   margin-left: auto;
//   margin-right: auto;
//   cursor: pointer;
//   &:hover {
//     background-color: #eee;
//   }
// `
const ShowMore = styled.div`
  padding: 1rem;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  background-color: var(--text-color);
  color: var(--site-background);
  cursor: pointer;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  @media screen and (min-width: 712px) {
    &:hover {
      background-color: var(--purple-main);
    }
  }
`